<script>
export default {
  functional: true,

  model: {
    event: 'change'
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  render(h, { data, props, listeners }) {
    const handleCheckboxInput = value => {
      listeners.change && listeners.change(value)
    }

    const _data = { ...data, on: undefined }

    return (
      <div
        {..._data}
        style={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <el-checkbox value={props.value} border onInput={handleCheckboxInput}>
          ออกบิล Vat ให้ลูกค้า
        </el-checkbox>
      </div>
    )
  }
}
</script>
